declare global {
    interface String {
        capitalize(): string;
    }
}

String.prototype.capitalize = function (): string {
    return this.charAt(0).toUpperCase() + this.toLowerCase().slice(1);
};

export const prettyTitle = (title: string): string =>
    title
        .replaceAll("_", " ")
        .split(" ")
        .map(word => (word.length > 5 ? word.capitalize() : word))
        .join(" ");
